import { createFeatureSelector, createSelector } from "@ngrx/store";
import { rotationalSpeedFeatureKey } from "./rotational-speed-chart.reducer";

export const selectRotationalSpeedState = createFeatureSelector(rotationalSpeedFeatureKey);

export const selectRotationalSpeed = createSelector(
  selectRotationalSpeedState,
  (state: any) => state
);